var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsButtonIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21427 0H0V15.7856C0 16.1076 0.127932 16.4165 0.355652 16.6442C0.583373 16.8719 0.892228 16.9998 1.21427 16.9998H16.9998V15.7856H1.21427V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8713 8.88856L15.5425 6.21729L12.8713 8.88856ZM9.47145 6.94582L11.4142 8.88856L9.47145 6.94582ZM4.85742 10.1028L8.01439 6.94582L4.85742 10.1028Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8713 8.88856L15.5425 6.21729M9.47145 6.94582L11.4142 8.88856M4.85742 10.1028L8.01439 6.94582",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2715 6.21786C16.6739 6.21786 17 5.89169 17 5.48933C17 5.08698 16.6739 4.7608 16.2715 4.7608C15.8691 4.7608 15.543 5.08698 15.543 5.48933C15.543 5.89169 15.8691 6.21786 16.2715 6.21786Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1426 10.3461C12.5449 10.3461 12.8711 10.0199 12.8711 9.61754C12.8711 9.21518 12.5449 8.88901 12.1426 8.88901C11.7402 8.88901 11.4141 9.21518 11.4141 9.61754C11.4141 10.0199 11.7402 10.3461 12.1426 10.3461Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7422 6.9461C9.14456 6.9461 9.47073 6.61993 9.47073 6.21757C9.47073 5.81522 9.14456 5.48904 8.7422 5.48904C8.33985 5.48904 8.01367 5.81522 8.01367 6.21757C8.01367 6.61993 8.33985 6.9461 8.7422 6.9461Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12892 11.5613C4.53128 11.5613 4.85745 11.2351 4.85745 10.8327C4.85745 10.4304 4.53128 10.1042 4.12892 10.1042C3.72656 10.1042 3.40039 10.4304 3.40039 10.8327C3.40039 11.2351 3.72656 11.5613 4.12892 11.5613Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsButtonIconActive);
export default __webpack_public_path__ + "static/media/AnalyticsButtonIconActive.b16563a2358c700abfc2e7e18f7149df.svg";
export { ForwardRef as ReactComponent };